<template>
  <div class="flex justify-center" ref="element" :style="centeredPadding">
    <!-- Unlinked when there is nowhere to go, e.g. a companion that has not
         paired yet, rather than pointing at a route that does not exist. -->
    <component :is="to ? RouterLink : 'div'" :to="to ?? undefined">
      <KonsolenkostLogo class="h-10" />
    </component>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';
import {
  RouterLink,
  type RouteLocationAsPathGeneric,
  type RouteLocationAsRelativeGeneric,
} from 'vue-router';
import KonsolenkostLogo from '../../components/app/KonsolenkostLogo.vue';
import { useAdjustPaddingCentered } from '../../composables/style/useAdjustPaddingCentered';

withDefaults(
  defineProps<{
    /** Where the logo leads. The companion overrides it with its session home. */
    to?: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric | null;
  }>(),
  {
    to: () => ({ name: 'home' }),
  },
);

const element = useTemplateRef<HTMLDivElement>('element');

const { centeredPadding } = useAdjustPaddingCentered(element, { minWidth: 175 });
</script>
